export const FETCH_DISCOVER_NEARBY_REQUEST = "FETCH_DISCOVER_NEARBY_REQUEST";
export const FETCH_DISCOVER_NEARBY_SUCCESS = "FETCH_DISCOVER_NEARBY_SUCCESS";
export const FETCH_DISCOVER_NEARBY_FAIL = "FETCH_DISCOVER_NEARBY_FAIL";
export const CLEAR_DISCOVER_NEARBY = "CLEAR_DISCOVER_NEARBY";
export const SET_DISCOVER_MODE = "SET_DISCOVER_MODE";
